import { render } from "./App.vue?vue&type=template&id=f6bccaaa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f6bccaaa&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__